<template>
    <Typography
        is="ul"
        type="paragraph"
        size="xs"
        :class="$style.breadcrumbs"
    >
        <li
            v-for="(item, index) in props.items"
            :key="item.title"
        >
            <Link
                :to="item.href"
                :disabled="item.disabled"
                color="white-40"
            >
                <span>{{ item.title }}</span>
                <meta
                    itemprop="position"
                    :content="`${index + 1}`"
                />
            </Link>
            <span v-if="index !== items.length - 1">/</span>
        </li>
    </Typography>
</template>

<script setup lang="ts">
import { RouteLocationRaw } from 'vue-router'

import Link from '@/components_new/Link.vue'
import Typography from '@/components_new/Typography.vue'

const props = defineProps<{
    items: { href: string | RouteLocationRaw; title: string; disabled?: boolean }[]
}>()
</script>

<style module>
.breadcrumbs {
    display: flex;
    flex-wrap: wrap;
    color: var(--white-40);
}
</style>
